import styled, { css } from "styled-components";

export const StyledWrappedTextArea = styled.div``;

export const StyledTextarea = styled.textarea<{
  isError?: boolean;
  isShadow?: boolean;
}>`
  width: 100%;
  min-height: 125px;
  background-color: var(--color-white);
  border: 2px solid
    ${({ isError }) =>
      isError ? "var(--color-red-200)" : "var(--color-gray-200)"};
  box-shadow: ${({ isShadow }) =>
    isShadow ? "0px 4px 30px 10px rgba(0, 0, 0, 0.1)" : "none"};
  border-radius: 5px;
  transition: 0.4s;
  padding: 9px 29px;

  &:disabled {
    cursor: not-allowed;
  }

  &::-webkit-input-placeholder {
    font-size: 20px;
    color: #8799b8;
  }

  ${({ isError }) => css`
    &:hover:not(:disabled) {
      border-color: ${isError ? `var(--color-red-200)` : `rgba(0, 0, 0, 0.3)`};
    }
  `};

  &:focus:not(:disabled) {
    box-shadow: ${({ isShadow }) =>
      isShadow ? "0px 4px 30px 5px rgba(0, 0, 0, 0.2)" : "none"};
    border-color: var(--primary);
  }
`;

export const StyledLabel = styled.label<{ isRequired?: boolean }>`
  display: inline-block;
  margin-bottom: 14px;
  font-weight: 400;
  padding-left: 8px;
  font-size: 18px;
  line-height: 1.26;
  color: var(--color-gray-900);

  ${({ isRequired }) =>
    isRequired
      ? css`
          &::after {
            content: "*";
            color: var(--color-red-200);
            margin-left: 3px;
          }
        `
      : css`
          &::after {
            content: "";
            display: none;
          }
        `};
`;

export const ErrorMessage = styled.span`
  display: block;
  position: absolute;
  padding-top: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.26;
  color: var(--color-red-200);
`;
